import ServicesFees from "../containers/services/ServicesFees";
import SEO from "../components/seo";
import { STATIC_PAGES_META } from "../lib/metaDataHelpers";
import { InitialResolver } from "@/lib/use.middlewares";

function Services() {
  return (
    <>
      <SEO {...STATIC_PAGES_META.services} />
      <ServicesFees />
    </>
  );
}
Services.getInitialProps = InitialResolver();
export default Services;
